import React, { useState, useEffect, useMemo } from 'react';
import './VendorCare.css'; // Assuming we are removing custom CSS
import { useLoader } from '../../../../context/LoaderProvider.jsx';

const initialVendorIssues = [
    {
        id: 1,
        name: 'Vendor One Supplies',
        email: 'vendor1@example.com',
        phone: '9999999999',
        summary: 'Payment not received for invoice #INV001',
        status: 'Pending',
        dateSubmitted: '2025-05-27',
        priority: 'High',
        lastFollowUp: '2025-05-28',
        assignedTo: 'Alice',
    },
    {
        id: 2,
        name: 'Vendor Two Tech',
        email: 'vendor2@example.com',
        phone: '8888888888',
        summary: 'Unable to upload new product catalog via API. This is a longer summary to test how text wrapping behaves in the table and modal views. We need to ensure it looks good and does not break the layout.',
        status: 'Escalated',
        dateSubmitted: '2025-05-25',
        priority: 'Urgent',
        lastFollowUp: '2025-05-26',
        assignedTo: 'Bob (Tech Lead)',
    },
    {
        id: 3,
        name: 'Vendor Three Logistics',
        email: 'vendor3@example.com',
        phone: '7777777777',
        summary: 'Incorrect product mapping for SKU #XYZ123',
        status: 'In Progress',
        dateSubmitted: '2025-05-26',
        priority: 'Medium',
        lastFollowUp: '2025-05-29',
        assignedTo: 'Carol',
    },
    {
        id: 4,
        name: 'Vendor Four Services',
        email: 'vendor4@example.com',
        phone: '6666666666',
        summary: 'Contract renewal query',
        status: 'Resolved',
        dateSubmitted: '2025-05-20',
        priority: 'Low',
        lastFollowUp: '2025-05-22',
        assignedTo: 'Alice',
    },
];

const STATUS_OPTIONS = ["OPEN", "IN_PROGRESS", "RESOLVED", "REJECTED"];
const PRIORITY_OPTIONS = ['Low', 'Medium', 'High', 'Urgent'];
const ASSIGNEE_OPTIONS = ['Unassigned', 'Alice', 'Bob (Tech Lead)', 'Carol', 'Support Team'];

const MODAL_BACKGROUND_COLOR = '#f8f9fa';

const Vendorcoustomercare = () => {
    const [vendorIssues, setVendorIssues] = useState(initialVendorIssues);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState('');
    const [selectedPriorityFilter, setSelectedPriorityFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const { showLoader, hideLoader } = useLoader();
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);

    const [currentIssueForView, setCurrentIssueForView] = useState(null);
    const [formData, setFormData] = useState({});
    // const [viewLoading, setViewLoading] = useState(false);
    // const [newStatus, setNewStatus] = useState(""); // ✅ Required state
    const defaultNewIssue = {
        name: '', email: '', phone: '', summary: '',
        status: STATUS_OPTIONS[0],
        dateSubmitted: new Date().toISOString().split('T')[0],
        priority: PRIORITY_OPTIONS[1],
        lastFollowUp: new Date().toISOString().split('T')[0],
        assignedTo: ASSIGNEE_OPTIONS[0],
    };

    const [vendorStats, setVendorStats] = useState({
        OPEN: 0,
        IN_PROGRESS: 0,
        RESOLVED: 0,
        REJECTED: 0,
        Total: 0,
    });


    const [filteredAndSearchedVendors, setFilteredAndSearchedVendors] = useState([]);
    //  const [filteredAndSearchedVendors, setFilteredAndSearchedVendors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTicket, setSelectedTicket] = useState(null);


    // const [responseMessage, setResponseMessage] = useState("");
    useEffect(() => {
        if (selectedTicket) {
            setResponseMessage(selectedTicket.responseMessage || "");
        }
    }, [selectedTicket]);

    const [newStatus, setNewStatus] = useState("OPEN");
    const [adminResponse, setResponseMessage] = useState("");
    const [viewLoading, setViewLoading] = useState(false);

    useEffect(() => {
        if (currentIssueForView) {
            setNewStatus(currentIssueForView.status || "OPEN");
            setResponseMessage(currentIssueForView.responseMessage || "");
        }
    }, [currentIssueForView]);

    // const [adminResponse, setAdminResponse] = useState("");

    const fetchVendorIssues = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("⚠️ Token is missing");
            return;
        }

        try {
            showLoader();
            const response = await fetch("https://backend.maamaas.com/food/api/vendor-tickets/all", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errData = await response.json();
                console.error("❌ Failed to fetch:", errData);
                throw new Error(errData.message || "API error");
            }

            const data = await response.json();
            setFilteredAndSearchedVendors(data);

            // ✅ Count status
            const counts = {
                OPEN: 0,
                IN_PROGRESS: 0,
                RESOLVED: 0,
                REJECTED: 0,
                Total: data.length
            };

            data.forEach(ticket => {
                if (counts.hasOwnProperty(ticket.status)) {
                    counts[ticket.status]++;
                }
            });

            setVendorStats(counts); // ✅ Update status stats
        } catch (err) {
            console.error("⚠️ Network Error:", err.message);
            setError("Server not reachable. Please try again later.");
        } finally {
            setLoading(false);
            hideLoader();
        }
    };


    const handleStatusChange = async (ticketId, newStatus, responseMessage) => {
        // ✅ Get token from localStorage
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("❌ Authorization token not found. Please log in again.");
            return;
        }

        if (!responseMessage || !responseMessage.trim()) {
            alert("⚠️ Please enter a response message before submitting.");
            return;
        }

        try {
            // ✅ Build the URL with query parameters
            const url = `https://backend.maamaas.com/food/api/vendor-tickets/respond/${ticketId}?responseMessage=${encodeURIComponent(
                responseMessage
            )}&status=${newStatus}`;

            // ✅ Send PUT request
            const response = await fetch(url, {
                method: "PUT", // changed from PATCH → PUT
                headers: {
                    Accept: "*/*",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                const errorText = await response.text();
                console.error("❌ Request failed:", errorText);
                alert(`❌ Request failed: ${errorText}`);
                return;
            }

            const data = await response.json();
            // console.log("✅ Ticket updated successfully:", data);
            alert("✅ Ticket updated successfully!");
            window.location.reload(); // optional: refresh page

        } catch (error) {
            console.error("❌ Error:", error);
            alert("❌ Something went wrong while updating the ticket.");
        }
    };






    useEffect(() => {
        fetchVendorIssues();
    }, []);

    const handleShowAddModal = () => {
        setFormData(defaultNewIssue);
        setShowAddModal(true);
    };
    const handleCloseAddModal = () => setShowAddModal(false);

    const handleShowEditModal = (issue) => {
        setFormData({ ...issue });
        setShowEditModal(true);
    };
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowViewModal = async (issue) => {
        setShowViewModal(true);
        setViewLoading(true);

        const ticketId = issue.id;
        const userId = issue.userId || issue.userID || issue.id;

        try {
            const token = localStorage.getItem("authToken");

            const response = await fetch(
                `https://backend.maamaas.com/food/api/vendor-tickets/${ticketId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error("Failed to fetch ticket by ID");
            }

            const data = await response.json();
            // console.log("🎯 Ticket by ID:", data);

            const ticket = Array.isArray(data) ? data[0] : data;
            setCurrentIssueForView(ticket);

            // ✅ Set adminResponse from ticket's existing response
            setResponseMessage(ticket.adminResponse || ""); // fallback to empty string if null
        } catch (error) {
            console.error("❌ Error fetching ticket by ID:", error);
            setCurrentIssueForView(null);
            setResponseMessage(""); // clear on error
        } finally {
            setViewLoading(false);
        }
    };

    const handleCloseViewModal = () => setShowViewModal(false);


    const handleMarkResolved = (id) => {
        setVendorIssues(prevIssues =>
            prevIssues.map(issue =>
                issue.id === id ? { ...issue, status: 'Resolved', lastFollowUp: new Date().toISOString().split('T')[0] } : issue
            )
        );
    };

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleAddIssueSave = (e) => {
        e.preventDefault();
        const newId = vendorIssues.length > 0 ? Math.max(...vendorIssues.map(i => i.id)) + 1 : 1;
        setVendorIssues(prevIssues => [
            { ...formData, id: newId, lastFollowUp: formData.lastFollowUp || new Date().toISOString().split('T')[0] },
            ...prevIssues
        ]);
        handleCloseAddModal();
    };

    const handleEditIssueSave = (e) => {
        e.preventDefault();
        setVendorIssues(prevIssues =>
            prevIssues.map(issue =>
                issue.id === formData.id ? { ...formData, lastFollowUp: formData.lastFollowUp || new Date().toISOString().split('T')[0] } : issue
            )
        );
        handleCloseEditModal();
    };



    const getStatusBadgeClass = (status) => {
        switch (status) {
            case 'OPEN': return 'bg-warning text-dark';
            case 'IN_PROGRESS': return 'bg-info text-dark';
            case 'RESOLVED': return 'bg-success text-white';
            case 'REJECTED': return 'bg-danger text-white';
            default: return 'bg-light text-dark';
        }
    };
    const getPriorityBadgeClass = (priority) => {
        switch (priority) {
            case 'Urgent': return 'bg-danger text-white';
            case 'High': return 'bg-warning text-dark';
            case 'Medium': return 'bg-info text-dark';
            case 'Low': return 'bg-success text-white';
            default: return 'bg-light text-dark';
        }
    };

    const renderFormFields = () => (
        <>
            <div className="row mb-3">

                <div className="col-md-6">
                    <label htmlFor="formName" className="form-label fw-medium">Vendor Name <span className="text-danger">*</span></label>
                    <input type="text" className="form-control form-control-sm" id="formName" name="name" value={formData.name || ''} onChange={handleFormChange} required />
                </div>
                <div className="col-md-6">
                    <label htmlFor="formEmail" className="form-label fw-medium">Email</label>
                    <input type="email" className="form-control form-control-sm" id="formEmail" name="email" value={formData.email || ''} onChange={handleFormChange} />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-md-6">
                    <label htmlFor="formPhone" className="form-label fw-medium">Phone</label>
                    <input type="tel" className="form-control form-control-sm" id="formPhone" name="phone" value={formData.phone || ''} onChange={handleFormChange} />
                </div>
                <div className="col-md-6">
                    <label htmlFor="formDateSubmitted" className="form-label fw-medium">Date Submitted <span className="text-danger">*</span></label>
                    <input type="date" className="form-control form-control-sm" id="formDateSubmitted" name="dateSubmitted" value={formData.dateSubmitted || ''} onChange={handleFormChange} required />
                </div>
            </div>
            <div className="mb-3">
                <label htmlFor="formSummary" className="form-label fw-medium">Issue Summary <span className="text-danger">*</span></label>
                <textarea className="form-control form-control-sm" id="formSummary" name="summary" rows="3" value={formData.summary || ''} onChange={handleFormChange} required></textarea>
            </div>
            <div className="row mb-3">
                <div className="col-md-6">
                    <label htmlFor="formStatus" className="form-label fw-medium">Status <span className="text-danger">*</span></label>
                    <select className="form-select form-select-sm" id="formStatus" name="status" value={formData.status || ''} onChange={handleFormChange} required>
                        {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                </div>
                <div className="col-md-6">
                    <label htmlFor="formPriority" className="form-label fw-medium">Priority <span className="text-danger">*</span></label>
                    <select className="form-select form-select-sm" id="formPriority" name="priority" value={formData.priority || ''} onChange={handleFormChange} required>
                        {PRIORITY_OPTIONS.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="formAssignedTo" className="form-label fw-medium">Assigned To</label>
                    <select className="form-select form-select-sm" id="formAssignedTo" name="assignedTo" value={formData.assignedTo || ''} onChange={handleFormChange}>
                        {ASSIGNEE_OPTIONS.map(a => <option key={a} value={a}>{a}</option>)}
                    </select>
                </div>
                <div className="col-md-6">
                    <label htmlFor="formLastFollowUp" className="form-label fw-medium">Last Follow-Up</label>
                    <input type="date" className="form-control form-control-sm" id="formLastFollowUp" name="lastFollowUp" value={formData.lastFollowUp || ''} onChange={handleFormChange} />
                </div>
            </div>
        </>
    );

    return (
        <div className=" mt-4 mb-5">
            {/* Stats Dashboard - Simplified for a single wrapping row */}
            <div className="row row-cols-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-start text-center mb-4 gy-3 p-3">
                {/* Using justify-content-start to align left if not filling the whole row */}

                {STATUS_OPTIONS.map(status => (
                    <div className="col" key={`stat-${status}`}>
                        <div className={`card h-100 text-white ${getStatusBadgeClass(status).split(' ')[0]}`}>
                            <div className="card-body p-2">
                                <h6 className="card-title mb-0">{vendorStats[status] || 0}</h6>
                                <small className="card-text">{status}</small>
                            </div>
                        </div>
                    </div>
                ))}
                <div className="col"> {/* Total card */}
                    <div className="card h-100 text-white " style={{ backgroundColor: "rgb(153, 0, 255)" }}>
                        <div className="card-body p-2">
                            <h6 className="card-title mb-0">{vendorStats.Total || 0}</h6>
                            <small className="card-text">Total  Issues</small>
                        </div>
                    </div>
                </div>
            </div>



            {/* Issues Table */}
            <div className="table-responsive shadow-sm roror2">
                <table className=" table-hover table-bordered align-middle caption-top">
                    <thead className="orrr" style={{ fontSize: '0.9rem', verticalAlign: 'middle' }}>
                        <tr>
                            <th className='p-2 text-center'>Vendor Id</th>
                            {/* <th className='p-2 text-center'>Vendor Name</th> */}
                            <th className='p-2 text-center'>Category</th>
                            <th style={{ minWidth: '250px' }} className='p-2 text-center'>Summary</th>

                            <th className='p-2 text-center'>Status</th>
                            <th className="p-2 text-center">Assigned To</th>
                            <th className='p-2 text-center'>Date</th>
                            <th className='p-2 text-center'>Time</th>
                            <th className='p-2 text-center'>Resolved At</th>
                            <th className='p-2 text-center'>Response</th>
                            <th style={{ minWidth: '130px' }} className='p-2 text-center'>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredAndSearchedVendors.length > 0 ? (
                            filteredAndSearchedVendors.map((issue) => (
                                <tr key={issue.id} style={{ fontSize: '0.9rem' }}>
                                    {/* <td className='p-2 text-center'>{issue.id}</td> */}
                                    <td className='p-2 text-center'>{issue.vendorId || 'N/A'}</td>
                                    <td className='p-2 text-center'><span className={`badge rounded-pill ${getPriorityBadgeClass(issue.ticketType)}`}>{issue.ticketType}</span></td>
                                    <td className="text-break p-2 text-center" style={{ maxWidth: '300px' }}>{issue.message}</td>

                                    <td className='p-2 text-center'><span className={`badge rounded-pill ${getStatusBadgeClass(issue.status)}`}>{issue.status}</span></td>
                                    <td className="p-2 text-center">{issue.assignedTo || "Unassigned"}</td>
                                    <td className="p-2 text-center">{new Date(issue.createdAt).toLocaleDateString()}</td>
                                    <td className="p-2 text-center">{new Date(issue.createdAt).toLocaleTimeString()}</td>
                                    <td className='p-2 text-center'>{issue.resolvedAt || 'N/A'}</td>
                                    <td className='p-2 text-center'>{issue.adminResponse || 'N/A'}</td>
                                    <td className='p-2 text-center'>
                                        <div className="btn-group btn-group-sm" role="group" aria-label="Issue Actions">
                                            <button type="button" className="btn btn-outline-info" onClick={() => handleShowViewModal(issue)}>View Details</button>
                                            {/* <button type="button" className="btn btn-outline-warning" onClick={() => handleShowEditModal(issue)}>Edit Issue</button> */}
                                            {/* {issue.status !== 'Resolved' && (
                                                <button type="button" className="btn btn-outline-success" onClick={() => handleMarkResolved(issue.id)}>Resolved</button>
                                            )} */}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center p-4">
                                    <h5 className="text-muted">No vendor issues found.</h5>
                                    <p className="text-muted">Try adjusting your filters or search term.</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Add/Edit Modal */}
            {(showAddModal || showEditModal) && (
                <div className="modal fade show d-block bg-white zoz" tabIndex="-1">
                    <div style={{ width: "-100px" }}>
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            {/* MODIFICATION HERE for modal background */}
                            <div className="modal-content" style={{ border: "0px solid" }}>
                                <form onSubmit={showAddModal ? handleAddIssueSave : handleEditIssueSave}>
                                    <div className="modal-header">
                                        <h5 className="modal-title">
                                            {showAddModal ? 'Add New Vendor Issue' : `Edit Vendor Issue (ID: ${formData.id})`}
                                        </h5>
                                        <button type="button" className="btn-close" onClick={showAddModal ? handleCloseAddModal : handleCloseEditModal} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        {renderFormFields()}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={showAddModal ? handleCloseAddModal : handleCloseEditModal}>
                                            <i className="bi bi-x-circle me-1"></i>Cancel
                                        </button>
                                        <button type="submit" className={`btn ${showAddModal ? 'btn-primary' : 'btn-warning'}`}>
                                            <i className={`bi ${showAddModal ? 'bi-plus-circle' : 'bi-save'} me-1`}></i>
                                            {showAddModal ? 'Save Issue' : 'Save Changes'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* View Details Modal */}
            {showViewModal && (
                <div className="modal fade show d-block bg-white zoz" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content" style={{ border: "0px solid" }}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {viewLoading
                                        ? "Loading Issue..."
                                        : `Issue Details (ID: ${currentIssueForView?.id || "N/A"})`}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseViewModal}
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {viewLoading ? (
                                    <p className="text-center text-muted">Fetching issue data...</p>
                                ) : currentIssueForView ? (
                                    <dl className="row gy-2">
                                        <dt className="col-sm-4 col-md-3 fw-semibold text-muted">Status:</dt>
                                        <dd className="col-sm-8 col-md-9">
                                            <div className="d-flex align-items-center gap-2">
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={newStatus}
                                                    onChange={(e) => setNewStatus(e.target.value)}
                                                >
                                                    <option value="OPEN">Open</option>
                                                    <option value="IN_PROGRESS">In Progress</option>
                                                    <option value="RESOLVED">Resolved</option>
                                                    <option value="REJECTED">Rejected</option>
                                                </select>
                                            </div>
                                        </dd>
                                        <label>Response Message</label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Enter response message"
                                            value={adminResponse}
                                            onChange={(e) => setResponseMessage(e.target.value)}
                                        />


                                    </dl>

                                ) : (
                                    <p className="text-danger">Failed to load issue details.</p>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() =>
                                        handleStatusChange(
                                            currentIssueForView?.id, // ticketId
                                            newStatus,               // selected status
                                            adminResponse            // pass response message here
                                        )
                                    }
                                >
                                    <i className="bi bi-save me-1"></i>Save
                                </button>



                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleCloseViewModal}
                                >
                                    <i className="bi bi-x-lg me-1"></i>Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Vendorcoustomercare;